// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Search from "@adl/XDL/Icons/Search";
import { color } from "@adl/XDL/Utilities";
import { TextFieldPresentationProps } from "@insite/mobius/TextField";
import { css } from "styled-components";

const xSearchFieldStyle: {
    input?: TextFieldPresentationProps;
} = {
    input: {
        sizeVariant: "default",
        iconProps: {
            src: Search,
            color: "secondary.main",
            size: 19,
            css: css`
                pointer-events: auto;
                &:hover {
                    color: ${color("common.ui1")};
                }
            `,
        },
        css: css`
            &&& {
                box-shadow: inset 0 1px 0 0 ${color("common.ui8", 0.1)};
                border-radius: 2px;
                &:hover,
                &:focus {
                    border-color: ${color("common.ui1")};
                }
            }
        `,
    },
};

export { xSearchFieldStyle };
